import styled from '@emotion/styled';
import { Paper } from '@mui/material';

const ModelEditorCard = styled(Paper)({
  marginBottom: 24,
  padding: 24,
});

export default ModelEditorCard;
